<template>
  <v-card>
    <v-row no-gutters class="my-2">
      <v-col cols="auto" class="mark-all">
        <v-btn x-small text @click="$emit('readNotes')" class="mt-1 mark-all-action"
          ><v-icon size="9x9" class="mark-all-icon my-0 mr-1 pa-0">$sl-check</v-icon> Markera alla
          lästa</v-btn
        >
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="1">
        <v-btn x-small icon @click="$emit('close')"><v-icon class="close-icon mt-0" small>$sl-close</v-icon></v-btn>
      </v-col>
    </v-row>

    <NotificationList />

    <v-row no-gutters class="mt-2">
      <v-col cols="12">
        <v-btn x-small block text @click="$emit('showNotes')" class="text-center view-all-notifications"
          >Se alla händelser</v-btn
        >
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import NotificationList from '@/components/Notifications/NotificationList'
// @group Common
// Provides NotificationDialog
export default {
    name: 'NotificationDialog',
  components: {
    NotificationList
  }
}
</script>

<style>
@media only screen and (max-width: 960px) {
  .v-dialog.notification-dialog {
    position: absolute;
    top: 34px;
    right: -2vw;
    width: 90vw;
    height: auto !important;
  }
}
.v-dialog.notification-dialog {
  margin-top: 15px !important;
  position: absolute !important;
  top: 50px !important;
  right: -24px !important;
  width: 90vw !important;
  height: auto !important;
}
.mark-all-action {
  display: flex;
  align-items: center;
  color: rgb(68, 68, 68) !important;
  font-family: 'Open Sans', sans-serif !important;
  font-size: 12px !important;
}
svg.mark-all-icon {
  max-height: 11px;
  max-width: 11px;
}
.close-icon {
  margin-top: 2px;
}
.mark-all {
  padding-top: 8px;
}
.view-all-notifications {
  color: rgb(68, 68, 68) !important;
  font-family: 'Open Sans', sans-serif !important;
  font-size: 14px !important;
}
.v-list-item.notification-item.unread {
  background-color: rgb(254, 252, 224);
}
.v-list-item.notification-item .title {
  font-family: 'Dosis', sans-serif !important;
  font-weight: 700 !important;
  font-size: 14px !important;
}
.v-list-item.v-list-item-subtitle {
  font-family: 'Open Sans', sans-serif !important;
  font-size: 12px !important;
}
.v-list-item.notification-item .v-list-item__content {
  padding-top: 6px;
  padding-bottom: 6px;
}
.v-list-item.notification-item .v-avatar {
  margin-bottom: 6px !important;
  margin-top: 6px !important;
}
</style>